import React, { Component } from 'react'
import titelbild from '../images/titelbild.js'

class Intro extends Component {
    render() {
        return (
            <div>
                <img className="Intro-flyer" src={titelbild[this.props.imgResIndex]} alt="Titelbild Pluspunkt" onLoad={() => this.props.onImgLoaded('Intro')} />
                <div className="Intro-title-description">
                    <h3>Willkommen auf unserer Webseite</h3>
                    wir sind die Akustik-Coverband Pluspunkt<br /><br />
                    <b>Gespielt wird, <div style={{ display: 'inline-block', color: "#f7991e" }}>was gefällt</div></b><br />
                    <p>
                        Im Raum Bayern, vor allem in den Landkreisen Donau-Ries und Weißenburg, spielen wir zu verschiedenen Anlässen,
                        ob in Bars, Kneipen oder bei privaten Feiern und Hochzeiten.
                        Unser Repertoire wechselt stetig und besteht aus aktuellen Hits sowie Rock- und Popklassikern der 80er und 90er.
                        Das Programm wird immer auf unser Publikum abgestimmt.
                    </p>
                    <p>
                        Mit zwei Gitarren, Cajon, Mundharmonika und zweistimmigen Gesang spielen wir auch gerne bei eurer Veranstaltung und freuen uns über eine unverbindliche Anfrage.
                    </p>

                    <h3>Diana und Florian</h3>
                </div>
            </div>
        );
    }
}

export default Intro;


// WEBPACK FOOTER //
// ./src/intro/intro.js